import React, { PropsWithChildren } from 'react';
import { createDefinitionTerm, DefinitionList } from '../../../_lib/components/DefinitionList';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { CategoryImage } from '../../../types/api/ImageType';

export type CategoriesElement = {
  title: string;
  maxValidityPeriodDays?: number;
  image?: CategoryImage;
};
export function CategoryElement({
  title,
  image,
  maxValidityPeriodDays,
  children,
}: PropsWithChildren<CategoriesElement>) {
  const { t } = useSonTranslation('Categories');

  const hasDeviatingValidity = maxValidityPeriodDays && maxValidityPeriodDays > 0;

  const titleWithValidity = () => (
    <>
      <p className="categories-block__category-title">
        <dfn className="invisible">{t('categoryTitle')}</dfn>
        <span className="font-regular-15-21">{title}</span>
      </p>
      <DefinitionList
        className="categories-block__definition-list"
        definitionTerms={[createDefinitionTerm(`${t('defaultValidationDate')}: `, `${maxValidityPeriodDays} Tage`)]}
      />
    </>
  );

  return (
    <div key={title} className="categories-block__wrapper">
      {image ? (
        <img className="categories-block__image" src={image.src} alt="" width={image.availableWidths.at(0)} />
      ) : null}
      <div className="categories-block__content font-regular-15-21">
        {hasDeviatingValidity ? titleWithValidity() : title}
      </div>
      <div className="categories-block__content-child">{children}</div>
    </div>
  );
}
